export function canInspectNutrition(account) {
  return !!account && account.claimed === 1 && account.trainer_permission === 1
}

export function canInspectExercise(account) {
  return !!account && account.has_exercise === true
}

export function getInspectionDestination(account, allowExercise = true) {
  if (canInspectNutrition(account)) return 'overview'
  if (allowExercise && canInspectExercise(account)) return 'exercise'
  return null
}
